import { ReactNode, useState } from "react";
import { Card, Collapse, CollapseProps } from "antd";
import styles from "./white-box.module.css";

import { ReactComponent as ArrowUp } from "images/table/Arrow-up.svg";
import { ReactComponent as ArrowDown } from "images/table/Arrow-down.svg";

interface WrapProps {
  children?: ReactNode | string;
  title?: string | ReactNode;
  id?: string;
  className?: string;
  /**
   * Когда включен режим collapse, не забудь добавить title
   */
  collapse?: {
    title: string | ReactNode;
    defaultOpen: boolean;
    propsItem?: CollapseProps["items"];
    className?: string;
  };
  image?: {
    src: string;
    alt?: string;
  };
}

export const WhiteBoxBlock: React.FC<WrapProps> = ({ children, title, id, className, image, collapse }) => {
  const [isOpen, setIsOpen] = useState(collapse?.defaultOpen);

  const handleCollapseChange: CollapseProps["onChange"] = (activeKeys) => {
    const keys = Array.isArray(activeKeys) ? activeKeys : [activeKeys];
    setIsOpen(keys.includes("1"));
  };

  const collapseItem: CollapseProps["items"] = [
    {
      key: "1",
      label: collapse?.title || title,
      children: children,
      ...collapse?.propsItem,
      className: collapse?.className,
    },
  ];

  if (image) {
    return (
      <Card
        title={title}
        bordered={false}
        className={`card-not-shadow ${styles.whiteBoxWithImage} ${className}`}
        id={id}
      >
        <div className={styles.whiteBoxLayout}>
          <div className={styles.whiteBoxImage}>
            <img src={image.src} alt={image.alt || "Background"} />
          </div>
          <div className={styles.whiteBoxContent}>{children}</div>
        </div>
      </Card>
    );
  }

  return (
    <>
      {!collapse ? (
        <Card title={title} bordered={false} className={`card-not-shadow ${className} card-padding-xl`} id={id}>
          {children}
        </Card>
      ) : (
        <Collapse
          items={collapseItem}
          bordered={false}
          expandIconPosition="end"
          activeKey={isOpen ? ["1"] : []}
          onChange={handleCollapseChange}
          expandIcon={({ isActive }) => (isActive ? <ArrowUp /> : <ArrowDown />)}
        />
      )}
    </>
  );
};
